import { isEmpty } from 'lodash';
import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const updateMyFoldersAPI = ({ data, id }) => {
    const url = `${API.MY_FOLDERS}/${id}`;
    return fetchData({ body: data, method: METHODS.PUT, url });
};

export const createMyFoldersAPI = ({ body }) => {
    const url = `${API.MY_FOLDERS}`;
    return fetchData({ body: body, method: METHODS.POST, url });
};

export const getAllMyFoldersAPI = ({ offset, limit, search = '', filter, account_id }) => {
    const queryParams = {
        offset: offset ? offset : '',
        account_id: account_id || '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        filter: !isEmpty(filter) ? encodeURIComponent(JSON.stringify(filter)) : '',
    };
    const url = constructURL(API.MY_FOLDERS, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const deleteMyFoldersAPI = ({ data = { id: '' } }) => {
    const url = `${API.MY_FOLDERS}`;
    return fetchData({ body: data, method: METHODS.DELETE, url });
};
